import { combineReducers } from 'redux';

import auth from './auth';
import profile from './profile';
import extras from './extras';
import notifications from './notifications';
import activeUsersReducer from './activeUsers';
import memoryUsageReducer from './memory/memoryUsage';

export default combineReducers({
  auth,
  profile,
  extras,
  notifications,
  activeUsers: activeUsersReducer,
  memoryUsage: memoryUsageReducer
});
